import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import _ from "lodash";
import { mapTreeJs, highlightHtml } from "@/utils/util.js";
export default {
  name: "pro-chiose-tree",
  props: {
    treeData: {
      type: Array,
      default() {
        return [];
      }
    },
    visible: {
      type: Boolean,
      default() {
        return false;
      }
    }
  },
  data() {
    return {
      search: {
        value: ""
      },
      searchTreeData: [],
      debouncedSearch: _.debounce(this.onSearch, 500)
    };
  },
  computed: {
    _treeData() {
      if (this.search.value) {
        return this.searchTreeData;
      } else {
        return this.treeData;
      }
    }
  },
  watch: {
    visible(val) {
      if (!val) {
        this.clear();
      }
    }
  },
  methods: {
    clear() {
      this.search.value = "";
      this.searchTreeData = [];
    },
    renderContent(h, {
      data
    }) {
      let style = {
        marginRight: "5px",
        color: "#2d8cf0"
      };
      let styleCheck = {
        marginLeft: "5px",
        color: "#3D7FFF"
      };
      const iconRender = () => {
        if (data.orgId) {
          return h("Icon", {
            "style": {
              ...style
            },
            "attrs": {
              "type": "md-folder"
            }
          });
        } else if (data.userId) {
          return h("Icon", {
            "style": {
              ...style
            },
            "attrs": {
              "type": "md-person"
            }
          });
        } else if (data.tagId) {
          return h("Icon", {
            "style": {
              ...style
            },
            "attrs": {
              "type": "md-pricetag"
            }
          });
        } else if (data.appId) {
          return h("Icon", {
            "style": {
              ...style
            },
            "attrs": {
              "type": "md-apps"
            }
          });
        }
      };
      return h("span", {
        "on": {
          "click": () => this.onClick(data)
        }
      }, [iconRender(), h("span", {
        "domProps": {
          "innerHTML": highlightHtml(data.name, this.search.value)
        }
      }), data.isCheck ? h("Icon", {
        "style": {
          ...styleCheck
        },
        "attrs": {
          "color": "#3D7FFF",
          "type": "md-checkmark"
        }
      }) : ""]);
    },
    onClick(item) {
      if (!item.isCheckDisabled) {
        if (item.userId) {
          this.findSameMember(item);
        } else {
          item.isCheck = !item.isCheck;
        }
        this.$emit("onChange", item);
      }
    },
    findSameMember(item) {
      let dg = (arr, i, parentChain = []) => {
        arr.forEach(v => {
          // 保存当前节点的父节点链
          const currentParentChain = [...parentChain, v];
          if (v.userId === i.userId) {
            v.isCheck = !v.isCheck;
            // 如果设置为选中状态，则展开所有父节点
            if (v.isCheck) {
              parentChain.forEach(parent => {
                parent.expand = true;
              });
            }
          }
          if (v.children && v.children.length > 0) {
            dg(v.children, i, currentParentChain);
          }
        });
      };
      dg(this.treeData, item);
    },
    onChangeSearch() {
      // 触发防抖函数
      this.debouncedSearch();
    },
    onSearch() {
      this.searchTreeData = mapTreeJs("name", this.search.value, this.treeData);
    }
  }
};